import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { PrivateRoute, useSession } from 'gunsi-auth'
import { Home } from './pages/Home.jsx'
import { Dashboard } from './pages/Dashboard.jsx'
import { Transactions } from './pages/Transactions.jsx'
import { Overview } from './pages/Overview.jsx'
import { Categories } from './pages/Categories.jsx'
import { Stats } from './pages/Stats.jsx'
import { CategoryDetail } from './pages/CategoryDetail.jsx'
import { Converter } from './pages/Converter.jsx'
import { Manage } from './pages/Manage.jsx'
import { Settings } from './pages/Settings.jsx'

function LocaleSync() {
  const { session } = useSession()
  useEffect(() => {
    const lang = session?.user?.locale
    if (lang) {
      localStorage.setItem('lang-pref', lang)
      document.documentElement.lang = lang
    }
  }, [session?.user?.locale])
  return null
}

export default function App() {
  return (
    <>
      <LocaleSync />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard"                element={<Overview />} />
          <Route path="/dashboard/:year"          element={<Overview />} />
          <Route path="/dashboard/:year/:month"   element={<Overview />} />
          <Route path="/transactions"               element={<Transactions />} />
          <Route path="/transactions/:year/:month"  element={<Transactions />} />
          <Route path="/categories"   element={<Categories />} />
          <Route path="/stats"                                  element={<Stats />} />
          <Route path="/stats/custom/:from/:to"                 element={<Stats />} />
          <Route path="/stats/:year"                            element={<Stats />} />
          <Route path="/stats/:year/:month"                     element={<Stats />} />
          <Route path="/stats/:year/:month/cat/:categoryId"     element={<CategoryDetail />} />
          <Route path="/converter"    element={<Converter />} />
          <Route path="/manage"       element={<Manage />} />
          <Route path="/settings"     element={<Settings />} />
        </Route>
      </Routes>
    </>
  )
}
